import { create } from "zustand";

/** A right-edge side sheet (Add an angle) is open: the root layout reserves its width so the
 *  page — list and paper detail — sits fully to its left, and toasts move clear of it. */
interface SideSheetState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSideSheetStore = create<SideSheetState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

/** Sheet width (sm and up) — keep in sync with the sheet's `sm:w-[480px]`. */
export const SIDE_SHEET_WIDTH = 480;
